import React, { useCallback } from 'react';

import { Button, Menu as RaMenu, MenuItemLink, useLogout } from 'react-admin';
import UserIcon from '@mui/icons-material/Group';
import SubscriptionsIcon from '@mui/icons-material/Subscriptions';
import SettingsIcon from '@mui/icons-material/Settings';
import StateIcon from '@mui/icons-material/StackedBarChart';
import { useMediaQuery } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useResourceAccess } from '../../hooks/useAccess';

const useStyles = makeStyles((theme: any) => ({
  activeMenuItem: {
    backgroundColor: theme.palette.action.selected,
    fontWeight: 'bold',
  },
  menuItem: {},
}));

const CustomMenuItem = ({ to, exact, primaryText, leftIcon, onClick }: any) => {
  const classes = useStyles();
  const isXSmall = useMediaQuery('(max-width:600px)');
  const isActive = exact
    ? // eslint-disable-next-line no-restricted-globals
      location.pathname === to.pathname
    : // eslint-disable-next-line no-restricted-globals
      location.pathname.startsWith(to.pathname);
  return (
    <MenuItemLink
      className={isActive ? classes.activeMenuItem : classes.menuItem}
      to={to}
      primaryText={primaryText}
      leftIcon={leftIcon}
      onClick={onClick}
      sidebarIsOpen={isXSmall}
    />
  );
};

export const Menu: React.FC = () => {
  const { canEditSettings } = useResourceAccess();
  const logout = useLogout();
  const handleLogout = useCallback(() => {
    logout();
  }, []);

  return (
    <RaMenu>
      {/* <DashboardMenuItem /> */}
      <CustomMenuItem
        to={{ pathname: '/user' }}
        primaryText="Users"
        leftIcon={<UserIcon />}
      />
      <CustomMenuItem
        to={{ pathname: '/gift-card' }}
        primaryText="Gift Cards"
        leftIcon={<SubscriptionsIcon />}
      />
      {canEditSettings() && (
        <CustomMenuItem
          to={{ pathname: '/config' }}
          primaryText="Config"
          leftIcon={<SettingsIcon />}
        />
      )}
      {canEditSettings() && (
        <CustomMenuItem
          to={{ pathname: '/state' }}
          primaryText="State"
          leftIcon={<StateIcon />}
        />
      )}

      <Button onClick={handleLogout}>
        <>Logout</>
      </Button>
    </RaMenu>
  );
};
